
<template>
    <Tab1Comp />
  </template>
  
  <script>
  import Tab1Comp from '@/components/RecruitmentTab1.vue';
  
    export default {
        name: "Tab1Vue",
        components: {
            Tab1Comp
        }
    }
  
  </script>